import { clearAuthSlice } from '../../store/reducers/authSlice';
import { clearChatSlice } from '../../store/reducers/chatSlice';
import {
  clearUISlice,
  setAutoSelectAgencyRole,
  setHasSkippedHelpSetup,
  setIsHelpSetupPopupOpen,
  setIsPaymentPopupOpen,
  setIsSwitchShopPopupOpen,
} from '../../store/reducers/uiSlice';
import {
  clearPreUserInvitation,
  clearUserSlice,
} from '../../store/reducers/userSlice';
import store from '../../store/store';

declare const window: any;

function localStorageHardReset() {
  store.dispatch(clearUserSlice());
  store.dispatch(clearPreUserInvitation());
  store.dispatch(clearAuthSlice());
  store.dispatch(clearChatSlice());
  store.dispatch(clearUISlice());
  store.dispatch(setIsPaymentPopupOpen(false));
  store.dispatch(setIsSwitchShopPopupOpen(false));
  store.dispatch(setAutoSelectAgencyRole(false));
  store.dispatch(setIsHelpSetupPopupOpen(false));
  store.dispatch(setHasSkippedHelpSetup(false));
  window.localStorage.clear();
}

export default localStorageHardReset;
